export const BundleType = {
    /** 일반 */
    NORMAL: 'NORMAL',
    /** 세금 관련 */
    TAX: 'TAX',
    /** 온라인 결제 가맹점 */
    ONLINE_PAYMENT_MERCHANT: 'ONLINE_PAYMENT_MERCHANT',
    /** 현장 결제 가맹점 */
    OFFLINE_PAYMENT_MERCHANT: 'OFFLINE_PAYMENT_MERCHANT',
} as const

type BaseBundle<Type extends Constant<typeof BundleType>, Extra = undefined> = {
    /** 타입 */
    type: Type
    /** 아이디 */
    id?: string
    /** 이름 */
    name?: string
    /** (이름 별칭) */
    subName?: string
    /** 라벨 목록 */
    labels: Constant<typeof ProductBundleLabel>[]
    /** 이메일 */
    email?: string
    /** 전화번호 */
    tel?: string
    /** 이미지 URL */
    imageUrl?: string
    /** 홈 URL */
    homeUrl?: string
    /** 문의 */
    contacts: Contact[]
    /** 국외이전 동의여부 */
    isCrossborderTransferAgreed?: boolean
} & ConditionalField<Extra, 'extra'>

export type Bundle =
    | BaseBundle<typeof BundleType.NORMAL>
    | BaseBundle<typeof BundleType.TAX>
    | BaseBundle<typeof BundleType.ONLINE_PAYMENT_MERCHANT>
    | BaseBundle<typeof BundleType.OFFLINE_PAYMENT_MERCHANT>

export const ProductBundleLabel = {
    /** 예약 */
    BOOKING: 'BOOKING',
    /** 로컬페이 */
    LOCAL_PAY: 'LOCAL_PAY',
    /** 블로그 */
    BLOG: 'BLOG',
    /** 카페 */
    CAFE: 'CAFE',
    /** 해피빈 */
    HAPPYBEAN: 'HAPPYBEAN',
} as const

export const ContactType = {
    /** 톡톡하기 */
    TALK_TALK: 'TALK_TALK',
    /** 1:1 문의 */
    DIRECT_INQUIRY: 'DIRECT_INQUIRY',
    /** 전화하기 */
    CALL: 'CALL',
    /** 문의하기 */
    CONTACT: 'CONTACT',
} as const

type BaseContact<Type extends Constant<typeof ContactType>, Extra = undefined> = {
    type: Type
} & ConditionalField<Extra, 'extra'>

type TalkTalkSubBundle = BaseContact<
    typeof ContactType.TALK_TALK,
    {
        /** 채널 아이디 */
        channelId: string
    }
>

export type Contact = BaseContact<Constant<Omit<typeof ContactType, 'TALK_TALK'>>> | TalkTalkSubBundle
